export function OutlineXIcon({
  width = 24,
  height = 24,
  fill = 'none',
  stroke = 'currentColor',
  strokeWidth = 2,
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.585 19.595C18.805 20.375 17.535 20.375 16.755 19.595L12.085 14.925L7.415 19.595C6.635 20.375 5.365 20.375 4.585 19.595C3.805 18.815 3.805 17.545 4.585 16.765L9.255 12.095L4.585 7.415C4.195 7.025 4.005 6.515 4.005 6.005C4.005 5.495 4.195 4.975 4.585 4.585C5.365 3.805 6.635 3.805 7.415 4.585L12.085 9.255L16.755 4.595C17.535 3.815 18.805 3.815 19.585 4.595C19.975 4.985 20.165 5.495 20.165 6.015C20.165 6.535 19.975 7.035 19.585 7.425L14.915 12.095L19.585 16.765C20.365 17.545 20.365 18.815 19.585 19.595Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
